// This is the modal that allows the user to edit the EERR Solar Water Heating details.

import { Component, Inject, Input } from '@angular/core';
import { AssetService } from '../../../services/configuration/asset.service';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eerr-solar-water-heating-details-modal',
  templateUrl: './eerr-solar-water-heating-details-modal.component.html',
})
export class EerrSolarWaterHeatingDetailsModalComponent {
  @Input() eeSWHDetails: any;
  @Input() eeRRDetails: any;
  assetCreateForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private assetService: AssetService
  ) {

  }

  save() {
    this.eeSWHDetails.assetId = this.eeRRDetails.assetId;
    this.assetService.updateEnergyEfficiencyRenewableRecoveryDetails(this.eeSWHDetails)
      .subscribe(n => {
        console.log(n);
        this.activeModal.close();
      });
  }

  cancel() {
    this.activeModal.close();
  }
}
